import HeaderActionsMenu from '@/components/common/HeaderActionsMenu';
import { Settings2 } from 'lucide-react';
import { usePageTitle } from '@/layouts/usePageTitle';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchStringDetail } from '@/api/stringDetail';
import type { StringDetail } from '@/api/stringDetail';
import { fetchInverterSolarPanelSummary, type SolarPanelSummary } from '@/api/inverters';
import StringDetailCard from '@/components/inverters/StringDetailCard';
import SolarPanelInfoCard from '@/components/solar-panels/SolarPanelInfoCard';
import StringPanelEditor from '@/components/solar-panels/StringPanelEditor';
import { useErrorToast } from '@/lib/notify';

export default function StringDetailPage() {
  const { id, stringNumber } = useParams<{ id: string; stringNumber: string }>();
  const [data, setData] = useState<StringDetail | null>(null);
  const [solarPanelSummary, setSolarPanelSummary] = useState<SolarPanelSummary[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [solarPanelLoading, setSolarPanelLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useErrorToast(error);
  const [editing,setEditing]=useState(false);
  const [revision,setRevision]=useState(0);
  const current = data?.current;
  usePageTitle(current && Number(current.inverter_string_inverter_id) === Number(id)
    && Number(current.inverter_string_string_number) === Number(stringNumber)
    ? `${current.inverter_string_power_plant_name} - İnverter - ${current.inverter_string_inverter_name} - String ${current.inverter_string_string_number}`
    : 'String');

  useEffect(() => {
    if (!id || !stringNumber) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetchStringDetail(Number(id), Number(stringNumber))
      .then(value => {if(!cancelled)setData(value);})
      .catch(() => {if(!cancelled)setError('Veri yüklenemedi');})
      .finally(() => {if(!cancelled)setLoading(false);});

    setSolarPanelLoading(true);
    setSolarPanelSummary(null);
    fetchInverterSolarPanelSummary(Number(id), Number(stringNumber))
      .then(value => {if(!cancelled)setSolarPanelSummary(value);})
      .catch(() => {if(!cancelled)setSolarPanelSummary(null);})
      .finally(() => {if(!cancelled)setSolarPanelLoading(false);});
    return () => {cancelled = true;};
  }, [id, stringNumber,revision]);

  return (
    <div className="flex flex-1 min-h-0 flex-col gap-4 overflow-y-auto p-4 pb-6">
      {!loading && !error && data && <HeaderActionsMenu label="String işlemleri" items={[{label:'String Panel Bilgisini Düzenle',icon:<Settings2 size={15} className="shrink-0 text-blue-600"/>,onSelect:()=>setEditing(true)}]}/>}



      {loading && (
        <div className="rounded-2xl bg-white p-8 shadow-md text-center text-gray-400">
          Yükleniyor...
        </div>
      )}


      {!loading && !error && !solarPanelLoading && Boolean(solarPanelSummary?.length) && (
        <SolarPanelInfoCard
          title="String Panel Bilgisi"
          data={solarPanelSummary}
          loading={solarPanelLoading}
        />
      )}

      {data && !loading && (
        <StringDetailCard
          current={data.current}
          ipv={data.ipv}
          upv={data.upv}
          pac={data.pac}
        />
      )}
      {editing && id && stringNumber && <StringPanelEditor key={`${id}:${stringNumber}`} inverterId={Number(id)} stringNumber={Number(stringNumber)} onClose={()=>setEditing(false)} onSaved={()=>setRevision(value=>value+1)}/>}
    </div>
  );
}
